import {useMergeabilityStatus} from '../../hooks/use-mergeability-status'
import {useMergeboxStatusCalculator} from '../../hooks/use-mergebox-status-calculator'
import {useValidatedMergeData} from './use-validated-merge-data'

export function useSidebarMergeData() {
  const validatedMergeData = useValidatedMergeData()

  const headSha = validatedMergeData?.headSha ?? ''
  const channels = validatedMergeData?.channels ?? null

  const {pullRequest: mergeBoxPullRequest, statusChecksData} = useMergeboxStatusCalculator({headSha, channels})
  const {status} = useMergeabilityStatus({headSha, channels})

  return {
    validatedMergeData,
    mergeBoxPullRequest,
    status,
    statusChecksData,
  }
}
